<template>
    <div>
        <rkm-area title="Motivos do atendimento" type="fieldset">
            <template slot="trailing">
                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                    small
                    title="Adicionar"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>

            <List :data="data" />

            <rkm-area
                v-if="data.form && data.form.ciapId"
                no-margin-top
                title="Informado durante o acolhimento"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <strong>CIAP 2</strong><br>
                        {{ data.form.ciap.codigo }} - {{ data.form.ciap.descricao }}
                    </rkm-col>
                    <rkm-col cols="6">
                        <strong>Observação</strong><br>
                        {{ data.form.observacao }}
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: {
        List,
        Modal,
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>